import { Link } from "react-router";

import { workspacePath } from "../routes/routes.model.ts";
import type { WorkspaceChoice } from "./workspace.model.ts";

/**
 * Workspaces as entities. The organisation's name leads because that is what
 * the user recognises — "Hauser & Wirth", not "Gallery". Two memberships of the
 * same kind are two separate cards, and now two separate addresses.
 */
export function WorkspaceChooser({ choices }: { choices: WorkspaceChoice[] }) {
  return (
    <ul className="workspace__choices">
      {choices.map((choice) => (
        <li key={choice.key}>
          <Link className="workspace__choice" to={workspacePath(choice.workspace)}>
            <span className="workspace__choice-body">
              <span className="workspace__choice-name">{choice.name}</span>
              <span className="workspace__choice-meta">{choice.meta}</span>
            </span>
            <span aria-hidden="true">›</span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
